class VideoPlayer extends HTMLElement {
  /** @type {NodeListOf<HTMLVideoElement>} */ videos = [...this.querySelectorAll('video')];
  /** @type {boolean} */ muted = this.dataset.muted === 'true';
  /** @type {boolean} */ paused = this.dataset.paused === 'true';
  /** @type {HTMLButtonElement} */ stateButton = this.querySelector('[data-state-button]');
  /** @type {HTMLButtonElement} */ soundButton = this.querySelector('[data-sound-button]');
  /** @type {HTMLVideoElement} */ intersectingVideo;

  connectedCallback() {
    this.videos.forEach((video) => this.observeVideo(video));
    this.stateButton?.addEventListener('click', (e) => this.handlePlayPause(e));
    this.soundButton?.addEventListener('click', (e) => this.handleSound(e));
  }

  /**
   * @param {HTMLVideoElement} video
   */
  observeVideo(video) {
    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
      if (isIntersecting) {
        this.intersectingVideo = video;
        !this.paused && video.play();
      } else {
        video.pause();
      }
    });
    observer.observe(video);
  }

  handlePlayPause(e) {
    e.preventDefault();
    this.paused = !this.paused;
    this.dataset.paused = this.paused;
    this.paused ? this.intersectingVideo.pause() : this.intersectingVideo.play();
    this.togglePlayPauseIcons();
  }

  togglePlayPauseIcons() {
    const playIcon = this.stateButton.querySelector('[data-icon="solid-play"]');
    const pauseIcon = this.stateButton.querySelector('[data-icon="solid-pause"]');
    playIcon.classList.toggle('hidden', !this.paused);
    pauseIcon.classList.toggle('hidden', this.paused);
  }

  handleSound(e) {
    e.preventDefault();
    this.muted = !this.muted;
    this.dataset.muted = this.muted;
    this.videos.forEach((video) => {
      video.muted = this.muted;
      this.toggleSoundButton();
    });
  }

  toggleSoundButton() {
    const soundOnIcon = this.soundButton.querySelector('[data-icon="solid-sound-on"]');
    const soundOffIcon = this.soundButton.querySelector('[data-icon="solid-sound-off"]');
    soundOnIcon.classList.toggle('hidden', this.muted);
    soundOffIcon.classList.toggle('hidden', !this.muted);
  }
}

customElements.define('video-player', VideoPlayer);
